import { useTranslation } from 'react-i18next';
import Tag from '@components/ui/Tag.tsx';

export const CheapestTag = () => {
  const { t } = useTranslation('client');
  return <Tag text={t('shared.cheapest')} color={'secondary'} colorSchema={'dark'} componentState={'default'} size={'xs'} />;
};

export const CheaperTag = () => {
  const { t } = useTranslation('client');
  return <Tag text={t('productDetail.buyForLess')} color={'success'} colorSchema={'dark'} componentState={'default'} size={'xs'} />;
};
